import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserDropdownComponent } from '../../components/header/user-dropdown/user-dropdown.component';
import { FilterStore, NetworkFilterPill } from '@core/stores/filter.store';
import { Dispatcher } from '@ngrx/signals/events';
import { clearFilter, clearPeriodFilter, toggleFilterDrawer } from '@core/events/filter.events';
import { LocaleSwitcherComponent } from '@shared/components/header/locale-switcher/locale-switcher.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterPillsComponent } from '@shared/components/filter/filter-pills/filter-pills.component';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    UserDropdownComponent,
    LocaleSwitcherComponent,
    TranslatePipe,
    FilterPillsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-header.component.html',
})
export class AppHeaderComponent {
  isApplicationMenuOpen = false;
  readonly isMobileOpen$;
  readonly filterStore = inject(FilterStore);
  readonly dispatcher = inject(Dispatcher);

  constructor(public sidebarService: SidebarService) {
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
  }

  handleToggle() {
    if (window.innerWidth >= 1280) {
      this.sidebarService.toggleExpanded();
    } else {
      this.sidebarService.toggleMobileOpen();
    }
  }

  toggleApplicationMenu() {
    this.isApplicationMenuOpen = !this.isApplicationMenuOpen;
  }

  openFilterDrawer(): void {
    this.dispatcher.dispatch(toggleFilterDrawer());
  }

  removePill(pill: NetworkFilterPill): void {
    this.dispatcher.dispatch(clearFilter({ key: pill.key }));
  }

  removePeriodPill(): void {
    this.dispatcher.dispatch(clearPeriodFilter());
  }
}
